<template>
  <a-card :body-style="{padding:'10px 20px 30px'}" style="border-radius: 8px" size="small">
    <template slot="title">产研部门交付报表</template>
    <div
      style="color:#201d1d"
    >
      <a-row class="main-card" :gutter="10">
        <a-col v-for="(item,idx) in mainDatas" :key="idx" :span="6" :class="idx>3?'add-top':''">
          <span style="margin-right: 8px;">{{ item.lable }}</span>
          <span>{{ item.value }}{{ item.unit }}</span>
        </a-col>
      </a-row>
      <a-row class="other-card" style="margin-top: 8px;border: 1px solid #dcd8d8;border-radius: 8px;padding:5px 0px">
        <a-col v-for="(item,idx) in otherDatas" :key="idx" :span="6" :class="idx>3?'add-top':''">
          <span style="margin-right: 8px;">{{ item.lable }}</span>
          <span>{{ item.value }}{{ item.unit }}</span>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import { getBrBaseCollecter } from '@/api/business/requirement';
export default {
  props: {
  },
  data() {
    return {
      dataList: [
        { lable: '员工平均每日吞吐量', name: 'employee_avg_throughput', value: 24, unit: '' },
        { lable: '需求吞吐量', name: 'requirement_throughput', value: 5, unit: '' },
        { lable: '对比需求吞吐量', name: 'comparison_requirement_throughput', value: 7, unit: '' },
        { lable: '吞吐量变化趋势', name: 'throughput_variation_trend', value: 9, unit: '' },
        { lable: '交付周期', name: 'delivery_cycle', value: 8, unit: '' },
        { lable: '对比交付周期', name: 'comparison_delivery_cycle', value: 4, unit: '' },
        { lable: '交付周期变化趋势', name: 'delivery_cycle_variation_trend', value: 10, unit: '' },
        { lable: '线上缺陷数', name: 'bug_sum', value: 30, unit: '' },
        { lable: '未上线需求数', name: 'not_online_requirement_sum', value: 230, unit: '' },
        { lable: '未上线需求平均等待时间', name: 'not_online_requirement_sleep_time', value: 230, unit: '' },
        { lable: '请假', name: 'ask_for_leave_day', value: 20, unit: '' },
        { lable: '加班', name: 'overtime', value: 10, unit: '' },
        { lable: '非工作日', name: 'standby_unattended_day', value: 30, unit: '' },
        { lable: '总天数', name: 'day_sum', value: 10, unit: '' },
        { lable: '团队规模', name: 'team_size', value: 0, unit: '' }
      ]
    };
  },
  computed: {
    mainDatas() {
      return this.dataList.slice(0, 4);
    },
    otherDatas() {
      return this.dataList.slice(4);
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getBrBaseCollecter().then(res => {
        const datas = res.data || [];
        datas.forEach(item => {
          if (item.name === '需求总数') {
            this.dataList[0].value = item.count || 0;
          } else if (item.name === '需求问答中') {
            this.dataList[1].value = item.count || 0;
          } else if (item.name === '进入生产需求') {
            this.dataList[2].value = item.count || 0;
          } else if (item.name === '已交付') {
            this.dataList[3].value = item.count || 0;
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main-card{
  font-weight:500;
  text-align:center;
  font-size:22px;
}
.other-card{
  font-weight:400;
  text-align:center;
  font-size:16px;
}
.add-top{
  margin-top: 10px;
}
</style>
